'use client'
import SignIn from "@/components/research/SignUp";
import {PageAnimation} from "@/components/animation/PageAnimation";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import ResearchList from "@/components/research/ResearchList";
import Login from "@/components/research/Login";
import Link from "next/link";
import styled from "styled-components";
import ThemeContainer from "@/components/theme/container";
import {toast} from "react-toastify";
import reactHtmlParser from "react-html-parser";




const ResearchPortal = ({data}) => {

    useEffect(() => {

    }, [])




    const token = Cookies.get('user-token')
    const [login, setLogin] = useState(false);
    const toastInfo = (msg) => toast.info(msg, {
        position: "top-right", autoClose: 4000, closeOnClick: true, progress: undefined,
    });


    useEffect(() => {
        if (token) {
            setLogin(true);
        } else {
            setTimeout(() => {
                toastInfo(
                    <div className={'toast-info'}>
                        Please login to view this content.
                        <Link  prefetch={true} href="/research/login"> Click Here to Login</Link>
                    </div>
                );
            }, 2000);
        }
    }, [token, setLogin]);


    return (
        <StyledComponent>

            {
                login ?
                    <ResearchList data={data}/>
                    :
                    <div className="login-wrapper">
                        <ThemeContainer colProps={{md: 12}}>
                            <h3>Please login to view this content <Link href={'research/login'}>Click Here</Link></h3>
                        </ThemeContainer>
                    </div>
            }
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    .login-wrapper{
        background: white;
        padding-top: 100px;
        padding-bottom: 120px;
        display: flex;
        align-items: center;
        text-align: center;
        
        a{
            color: #B0A47E;
            &:hover{
                color: #E62E43;
            }
        }
    }
`;
export default ResearchPortal;